import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, ProtectedRoute, PublicOnlyRoute } from "./components/ProtectedRoute";

import Login from "./Login";
import Signup from "./Signup";

import Dashboard from "./pages/Dashboard";
import Editor from "./pages/Editor";
import Account from "./pages/Account";
import Premium from "./pages/Premium";
import History from "./pages/History";
import ConvertPage from "./pages/ConvertPage";
import AdminPage from "./pages/AdminPage";

export default function App() {

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>

          {/* Public: a logged-in user is redirected to the dashboard */}
          <Route path="/" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
          <Route path="/login" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
          <Route path="/signup" element={<PublicOnlyRoute><Signup /></PublicOnlyRoute>} />

          {/* Protected: needs a session the server has just confirmed */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/editor/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/premium" element={<ProtectedRoute><Premium /></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
          <Route path="/convert" element={<ProtectedRoute><ConvertPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />

        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
